













import { MrfiktivCustomFieldListElementViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import SelectCustomFields from "@/components/report/SelectCustomFields.vue";
import { CustomFieldEnum } from "@/store/modules/custom-field.store";

@Component({
  components: {
    SelectCustomFields
  }
})
export default class CustomFieldConfigurationForm extends Vue {
  @Prop()
  value!: MrfiktivCustomFieldListElementViewModelGen[];

  @Prop({ default: false })
  disabled!: boolean;

  @Prop({ default: () => [] })
  types?: CustomFieldEnum[];

  @Prop({ default: () => [] })
  omitIds!: string[];

  @Prop({ default: true })
  showManageButton!: boolean;
}
